import React from 'react';
import { connect } from "react-redux";
import { lzGetAssetUrl } from '../../../services/LzUtils';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import { getUserLinks } from './nav-items';

class PrivateLayoutMainBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      avatarEl: null,
    };

    this.avatarLinks = getUserLinks();
  }

  avatarLink(code) {
    const { history } = this.props;
    history.push(code);
    this.setState({ avatarEl: null });
  }

  render() {
    const { avatarEl } = this.state;
    const { drawerOpen, onDrawerToggle, authDealer } = this.props;

    return (
      <div className="lz-private-main-bar">
        <div className="lz-private-main-bar-section">
          <IconButton onClick={() => onDrawerToggle()}>
            {drawerOpen ? <ArrowBackIcon /> : <MenuIcon />}
          </IconButton>
        </div>
        <div className="lz-private-main-bar-section">
          <IconButton onClick={(ev) => this.setState({ avatarEl: ev.currentTarget })}>
            <Avatar
              alt={authDealer.name}
              src={authDealer.avatar_media ? lzGetAssetUrl(authDealer.avatar_media_src) : null}
            >{authDealer.avatar_initials}</Avatar>
          </IconButton>
          <Menu keepMounted className="lz-avatar-menu" anchorEl={avatarEl} open={!!avatarEl} onClose={() => this.setState({ avatarEl: null })}>
            {this.avatarLinks.map((link, dex) =>
              <MenuItem key={'lnk-' + dex} onClick={() => this.avatarLink(link.route)}>
                <ListItemIcon>{link.icon}</ListItemIcon>
                <Typography>{link.title}</Typography>
              </MenuItem>
            )}
          </Menu>
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    authDealer: state.auth.dealer,
  }
};

export default connect(
  mapStateToProps
)(withRouter(PrivateLayoutMainBar));
